import MenuIcon from '@mui/icons-material/Menu';
import QrCodeScannerIcon from '@mui/icons-material/QrCodeScanner';
import MuiAppBar, { AppBarProps as MuiAppBarProps } from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import IconButton from '@mui/material/IconButton';
import Toolbar from '@mui/material/Toolbar';
import { styled } from '@mui/material/styles';
import * as React from 'react';
import { useContext } from 'react';
import { AuthContext } from '../../contexts/user-context/user-context';
import { UserType } from '../../enums/users';
import MainContent from '../router/main';
import QuickScanDialog from './quick-scan-dialog';
import SideNav from './side-nav/side-nav';
import { drawerWidth } from './side-nav/side-nav.config';
import { DrawerHeader } from './side-nav/side-nav.utils';
import { isMobile, isTablet } from 'react-device-detect';
import DeliveryBatchDialog from '../delivery-company-components/delivery-tasks/delivery-task-dialog';
import OrderLookupDialog from './order-lookup-dialog';
import PickupTaskDialog from '../delivery-company-components/pickup-tasks/pickup-task-dialog';
import MerchantInvoiceLookupDialog from './merchant-invoice-lookup-dialog';
import ShelfLookupDialog from './shelf-dialog';
import DeliveryBatchQuickScanDialog from '../driver-components/quick-scan-dialogs/delivery-batch-dialog';
import PaymentTaskhQuickScanDialog from '../driver-components/quick-scan-dialogs/payment-task-dialog';
import DeliveryTaskQuickScanDialog from '../driver-components/quick-scan-dialogs/delivery-task-dialog';
import SimpleBottomNavigation from './bottom-nav/bottom-nav';
import { generateWhatsAppLink } from '../driver-components/driver-order-lookup/utils';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import { Chip, CircularProgress, Fab, Typography } from '@mui/material';
import OrderDataCheck from '../driver-components/quick-scan-dialogs/order-data-check';
import Draggable from 'react-draggable';
import { HolidayToggleButton } from '../common/holiday-theme/holiday-toggle-button';
import { FloatingFAB } from './draggable-fab';
import TemporaryPackageLookupDialog from './temporary-package-lookup-dialog';
import { orange } from '@mui/material/colors';
import { Edit, HelpCenter, Update, Upgrade, Warehouse } from '@mui/icons-material';
import AppBannerList from './banner';
import { DomainForcedOrganisationContext } from '../../contexts/domain-forced-organisation-context';
import { IconWithText } from '../common/styles/components';
import NotificationsBell from '../common/notifications-bell';
import NotificationPermissionCard from '../common/notification-permissions';
import { useSelectedBranch } from '../../contexts/selected-branch-context';
import { HolidayCountdown } from '../common/holiday-theme/countdown-timer';
import { useHolidayTheme } from '../../contexts/holiday-theme-context';
import BranchDropdownSelector from '../common/branch-dropdown-selector/branch-dropdown-selector';
interface AppBarProps extends MuiAppBarProps {
  open?: boolean;
}

const AppBar = styled(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'open',
})<AppBarProps>(({ theme, open }) => ({
  transition: theme.transitions.create(['width', 'margin'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(open && {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth})`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}));

const AppLayout = () => {
  const [open, setOpen] = React.useState(false);
  const [scanning, setScanning] = React.useState(false);

  const {selectedBranch} = useSelectedBranch();

  const { forcedOrganisation, isLoading} = useContext(DomainForcedOrganisationContext)
  const { isHolidaySeason, holidayType } = useHolidayTheme();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const { user, config } = useContext(AuthContext);

  if (user === null) {
    open && setOpen(false);
  }

  return (
    <>
    <Box sx={{ display: 'flex', height: '100%' }}>
      <CssBaseline />
      <div>
        <AppBar position="fixed" open={open} style={{ zIndex: 501 }}>
          <Toolbar>
            {[
              UserType.ORGANISATION,
              UserType.EMPLOYEE,
              UserType.MERCHANT,
            ].includes((user?.type ?? '') as UserType) && (
                <IconButton
                  color="inherit"
                  aria-label="open drawer"
                  onClick={handleDrawerOpen}
                  edge="start"
                  sx={{
                    mr: 0,
                    ...(open && { display: 'none' }),
                  }}
                >
                  <MenuIcon />
                </IconButton>
              )}
            <div
              style={{
                display: 'flex',
                justifyContent: 'space-between',
                width: '100%',
                alignItems: "center"
              }}
            >
              {isLoading ? <CircularProgress color={"secondary"} size={20} /> : <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Box
                    component="img"
                    sx={{
                      height: 52,
                      p: 1,
                      display: "flex",
                      alignItems: "center",
                    }}
                    alt="Your logo."
                    src={forcedOrganisation && forcedOrganisation.navbar_logo ? forcedOrganisation.navbar_logo : '/main-logo-for-nav.png'}
                  />


                  {forcedOrganisation && forcedOrganisation.navbar_logo && (
                    <Box display={"flex"} flexDirection={"column"} gap={0}> 
                        <Typography sx={{fontWeight: 'bold'}}>{forcedOrganisation.brand}</Typography> 

                        <IconWithText>
                        <Typography variant='caption'> Powered by Parcel Tracer</Typography>
                        </IconWithText>
                    </Box>
                  )}
            </div>}

              

              

                  <Box display="flex" alignItems="center" gap={1}>
                  <HelpCenter sx={{ color: 'white' }} fontSize="large" onClick={() => window.open(generateWhatsAppLink('+33753560667'), '_blank')} />
                  {user && <NotificationsBell />}
                  <HolidayToggleButton />
                     
                    {user &&
                          [
                            UserType.ORGANISATION.toString(),
                            UserType.EMPLOYEE.toString(),
                            UserType.DRIVER.toString(),
                          ].includes(user.type) && (
                              <IconButton onClick={() => setScanning(true)}>
                                <QrCodeScannerIcon
                                  sx={{ color: 'white' }}
                                  fontSize="large"
                                />
                              </IconButton>)
                        }
                  </Box>

                
            </div>
          </Toolbar>

        </AppBar>

      </div>

      {[UserType.ORGANISATION, UserType.EMPLOYEE, UserType.MERCHANT].includes(
        user?.type as UserType
      ) && (
          <SideNav
            setOpen={setOpen}
            open={open}
            handleDrawerClose={handleDrawerClose}
          />
        )}
      <Box
        id="this box"
        component="main"
        sx={{
          width: (isMobile && !isTablet) ? '100%' : `calc(100% - ${drawerWidth})`,
          flexGrow: 1,
        }}
      >
        <DrawerHeader />
        {process.env.REACT_APP_ENV === 'staging' && (
                  <div style={{ display: 'fixed',  top: 0, width: '100%', background: '#5f91a8', color: '#fff', textAlign: 'center'}}>
                    STAGING ENVIRONMENT
                  </div>
          )}
          <Box sx={{
            p: user ? 3 : 0,
            pt: user == undefined ? 3 : undefined, 
            pr: user == undefined ? 3 : undefined, 
            pb: user?.type === UserType.DRIVER ? 7 : undefined,}}
          >
            <div style={{ display: "flex", alignItems: "center", userSelect: "none", justifyContent: "space-between" }}>
                <BranchDropdownSelector onDrawerOpen={handleDrawerOpen} />
              {(isHolidaySeason && user) ?  <HolidayCountdown /> : <Box visibility={"hidden"}>.</Box>}
              
                <Chip onClick={() => window.location.reload()} icon={<Update />} sx={{ background: orange[400], cursor: "pointer", userSelect: "none" }} label={`v${process.env.REACT_APP_VERSION}`} />
              </div>

              <AppBannerList />
            

            <MainContent />
            
          </Box>
         

        </Box>
       
  
      {user?.type === UserType.DRIVER && <SimpleBottomNavigation />}
      {(user?.type === UserType.ORGANISATION ||
        user?.type === UserType.EMPLOYEE) && (
          <QuickScanDialog
            open={scanning}
            onClose={() => setScanning(false)}
            deliveryBatchHandler={(id, reset) => (
              <DeliveryBatchDialog taskID={id} onClose={reset} />
            )}
            orderHandler={(id, reset) => (
              <OrderLookupDialog id={id} onCloseDialog={reset} />
            )}
            pickupTaskHandler={(id, reset) => (
              <PickupTaskDialog taskID={id} onClose={reset} />
            )}
            merchantInvoiceHandler={(id, reset) => (
              <MerchantInvoiceLookupDialog invoice_id={id} onClose={reset} />
            )}
            shelfHandler={(id, reset) => (
              <ShelfLookupDialog shelf_id={id} onClose={reset} />
            )}
            temporaryPackageHandler={(id, reset) => (
              <TemporaryPackageLookupDialog id={id} onCloseDialog={reset} />
            )}
          />
        )}

      {user?.type === UserType.DRIVER && (
        <QuickScanDialog
          open={scanning}
          onClose={() => setScanning(false)}
          deliveryBatchHandler={(id, reset) => (
            <DeliveryBatchQuickScanDialog id={id} onClose={reset} />
          )}
          merchantInvoiceHandler={(id, reset) => (
            <PaymentTaskhQuickScanDialog id={id} onClose={reset} />
          )}
          orderHandler={(id, reset) => (
            <OrderDataCheck id={id} onClose={reset} />
          )}
          temporaryPackageHandler={(id, reset) => (
            <TemporaryPackageLookupDialog id={id} onCloseDialog={reset} />
          )}
        />
      )}
    </Box>
    </>
    
  );
};

export default AppLayout;
